module.exports = __webpack_public_path__ + "static/media/evercellCarousel1.10bed940.png";